import Http from "../../common/utils/Http";

export const termsList = async () => {
    return await Http.get('home/content/conditions');
}
